import { cn } from '../utils';

const isValid = (c: string | undefined) =>
  Boolean(c?.match(/^#[A-Fa-f0-9]{3,8}$/));

// A swatch that previews the chosen colour behind a hex text field — mirrors
// the simple-lms branding ColorInput.
export function ColorInput({
  className,
  value,
  onChange,
}: {
  className?: string;
  value?: string;
  onChange?: (color: string) => void;
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-center overflow-hidden rounded-md p-8',
        className,
      )}
      style={{ backgroundColor: isValid(value) ? value : '#FF6B6C' }}
    >
      <input
        type="text"
        className="bg-background/90 w-28 rounded-md p-3 text-center font-mono"
        value={value ?? ''}
        placeholder="#000000"
        onChange={(ev) => onChange?.(ev.target.value)}
      />
    </div>
  );
}
